import { useEffect, useRef } from 'react'

const useBeforeUnload = (action) => {
  const callbackRef = useRef()

  callbackRef.current = action

  useEffect(() => {
    const onUnload = (e) => callbackRef.current(e)

    window.addEventListener('beforeunload', onUnload)

    return () => window.removeEventListener('beforeunload', onUnload)
  }, [callbackRef])
}

export default useBeforeUnload
